var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action-button pull-right",class:{ primary: _vm.primary },attrs:{"data-type":_vm.type,"data-href":_vm.link},on:{"click":_vm.onClickActionButton}},[_vm._v("\n\t"+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }